<template>
  <div v-if="!showModal">
    <a-spin :spinning="loading">
      <a-form ref="formRef" :model="formState" name="form" @finish="onSearch">
        <a-row>
          <a-form-item class="ui-form__item" name="organizationId" label="影院组织">
            <a-select placeholder="请选择影院组织" v-model:value="formState.organizationId" style="width: 250px;"
                      @change="getAllCinemaList">
              <!-- <a-select-option :value="0">全部</a-select-option> -->
              <a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="ui-form__item" name="cinemaId" label="所属影院">
            <a-select placeholder="请选择所属影院" v-model:value="formState.cinemaId" style="width: 250px;">
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

        </a-row>

        <a-row>
          <a-col :span="18">
<!--            <a-button v-permission="['ledger_manage_account_add']" type="primary" @click="onAdd">新增</a-button>
            <a style="margin-left: 10px;" @click="onTipShow">
              默认账号说明
            </a>-->
          </a-col>
          <a-col :span="6" style="text-align: right;">
            <a-button style="margin-right: 10px" type="primary" html-type="submit">搜索</a-button>
            <a-button @click="onReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form>

      <div style="margin-top: 20px;">
        <a-table :pagination="pagination" rowKey="id" :columns="columns" :dataSource="list" tableLayout="auto">
          <template #bodyCell="{ column, record, index }">

            <template v-if="column.key === 'paymentAccountName'">
              <div v-if="record.paymentAccountName">{{ record.paymentAccountName }}</div>
              <div v-else>系统分账账号</div>
            </template>

            <template v-if="column.key === 'action'">
              <a-dropdown :trigger="['click', 'hover']">
                <a-button @click.prevent>操作 <Icon icon="DownOutlined"></Icon>
                </a-button>
                <template #overlay>
                  <a-menu>
                    <div>
                      <a-menu-item @click="onAccountSelect(record)">
                        修改
                      </a-menu-item>
                    </div>
                  </a-menu>
                </template>
              </a-dropdown>
            </template>
          </template>
        </a-table>
      </div>
    </a-spin>
  </div>
  <a-modal v-model:visible="accountVisible" title="修改影院分账账号" width="700px" @cancel="onAccountCancel" @ok="onAccountSubmit">
    <a-form ref="accountFormRef" :model="accountForm" name="accountForm">
      <a-form-item class="ui-form__item" name="paymentAccountId" label="分账账号">
        <a-select placeholder="请选择分账账号" v-model:value="accountForm.paymentAccountId" style="width: 250px;">
          <a-select-option v-for="item in paymentAccountList" :vlaue="item.id" :key="item.id">
            <a-tooltip>
              <template #title>{{ item.remark || '' }}</template>
              {{ item.accountName }}
            </a-tooltip>
          </a-select-option>
        </a-select>
        <Icon icon="RedoOutlined" style="margin-left: 10px" @click="getPaymentAccountList(1)"/>
      </a-form-item>
    </a-form>
  </a-modal>
<!--  <temp v-else :isEdit="isEdit" :isDetail="isDetail" :id="id" @back="onBack"></temp>-->
</template>

<script>
  import {
    Icon
  } from '@/components/icon/icon.js';
  import {
    paymentAccountList,
    setDefaultPaymentAccount,
    clearDefaultPaymentAccount,
    getCinemaAccountList,
    setCinemaAccount,
  } from '@/service/modules/ledger.js';
  import {
    getOrganizationList,
    getCinemaList,
  } from '@/service/modules/cinema.js';
  import { h } from 'vue';
  export default {
    components: {
      Icon,
      // temp
    },
    data() {
      return {
        loading: false,
        formState: {},
        showModal: false,
        organizationList: [],
        cinemaAllList: [],
        list: [],
        columns: [{
          title: '影院名称',
          dataIndex: 'name',
        }, {
          title: '影院编码',
          dataIndex: 'code',
        }, {
          title: '分账账号',
          dataIndex: 'paymentAccountName',
          key: 'paymentAccountName',
        }, {
          title: '账号编码',
          dataIndex: 'paymentAccountNo',
          key: 'paymentAccountNo',
        }, {
          title: '操作',
          key: 'action'
        },],
        pagination: {
          showSizeChanger: true,
          showQuickJumper: true,
          size: "middle",
          showTotal: (total) => {
            return "共 " + total + " 条";
          },
          total: 0,
          current: 1,
          pageSize: 10,
          onChange: (page) => {
            this.pagination.current = page;
            this.getData();
          },
          onShowSizeChange: (page, pageSize) => {
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getData();
          }
        },
        isEdit: false,
        isDetail: false,
        id: 0,
        searchData: [],
        formEdit: {},
        accountVisible: false,
        accountForm: {},
        paymentAccountList: [],
      }
    },
    created() {
      this.getOrganizationList();
      this.getPaymentAccountList();
    },
    methods: {
      onBack() {
        this.showModal = false;
        this.getData();
      },
      onSearch() {
        this.pagination.current = 1;
        // //this.pagination.pageSize = 10;
        this.searchData = JSON.parse(JSON.stringify(this.formState));
        this.getData();
      },
      onReset() {
        this.$refs.formRef.resetFields();
        this.onSearch();
      },
      async getData() {
        const postData = {
          page: this.pagination.current,
          pageSize: this.pagination.pageSize,
          ...this.searchData,
        }
        this.loading = true;
        try{
          let res = await getCinemaAccountList(postData);
          if (res.code == 200) {
            this.list = res.data.list;
            this.pagination.total = res.data.totalCount;
          }
          this.loading = false;
        }catch(e){
          this.loading = false;
        }
      },
      onAdd() {
        this.id = 0;
        this.isEdit = false;
        this.showModal = true;
        this.isDetail = false;
      },
      onEdit(val) {},
      onDetail(val){
        this.id = val.id;
        this.isEdit = false;
        this.isDetail = true;
        this.showModal = true;
      },
      async onSetDefaultAccount(item) {
        this.$confirm({
          content: '设置账号为默认分账账号',
          onOk: async () => {
            const ret = await setDefaultPaymentAccount({
              id: item.id
            });
            if (ret.code == 200) {
              this.$message.success('设置成功');
              this.getData();
            }
          }
        })
      },
      async getPaymentAccountList(showTips = 0) {
        const postData = {
          page: 1,
          pageSize: 99,
        }
        let res = await paymentAccountList(postData);
        if (res.code == 200) {
          res.data.list.unshift({id: 0, accountName: '系统分账账号'});
          this.paymentAccountList = res.data.list;
          if (showTips) {
            this.$message.success('更新成功');
          }
        }
      },
      onAccountSelect(item) {
        this.accountForm.cinemaId = item.id;
        this.accountForm.paymentAccountId = item.paymentAccountId;
        this.accountVisible = true;
      },
      onAccountCancel() {
        this.accountForm = {};
        this.accountVisible = false;
      },
      async onAccountSubmit() {
        const postData = this.accountForm;
        this.loading = true;
        const ret = await setCinemaAccount(postData);
        if (ret.code == 200) {
          this.$message.success('设置成功');
          this.getData();
        }
        this.accountForm = {};
        this.accountVisible = false;
        this.loading = false;
      },
      onResetAccount(item) {
        this.$confirm({
          title: '提示',
          content: '确定移除默认账号?',
          onOk: async () => {
            this.loading = true;
            const ret = await clearDefaultPaymentAccount({
              id: item.id
            });
            if (ret.code == 200) {
              this.$message.success('设置成功, 当前默认账号为系统分账账号');
              this.getData();
            }
            this.loading = false;
          }
        })
      },
      transChannelType(type){
        const typeObj = {
          'HUIFU': '汇付'
        }
        return typeObj[type];
      },
      onCancel() {
        this.visibleEdit = false;
        this.$refs.form.resetFields();
      },
      async onTipShow() {
        const postData = {
          page: 1,
          pageSize: 99,
        }
        this.loading = true;
        try{
          let res = await paymentAccountList(postData);
          if (res.code == 200) {
            this.loading = false;
            let defaultAccount;
            this.list.forEach((item)=>{
              if(item.isDefault) {
                defaultAccount = item;
              }
            });
            this.$confirm({
              title: '分账账号说明',
              content: () => h('div', [
                h('p', `当前默认账号：${defaultAccount? defaultAccount.accountName : '系统分账账号'}`),
                h('p', '账号类型分为：1.系统分账账号，2.分账列表中的账号。'),
                h('p', '在未配置默认分账账号时，会直接使用系统分账账号作为默认分账账号。'),
              ]),
              // h('p', { style: { color: '#ff4d4f' } }, '这是红色的第二行内容。'),
            })
          }
        } catch(e){
          this.loading = false;
        }
      },
      async getOrganizationList() {
        let ret = await getOrganizationList({
          page: 1,
          pageSize: 999999
        });
        if (ret.code === 200) {
          this.organizationList = ret.data.list;
          if (this.organizationList.length) {
            this.formState.organizationId = this.organizationList[0].id;
            this.getAllCinemaList(this.formState.organizationId);
            this.getData();
          }
        }
      },
      async getAllCinemaList(organizationId) {
        this.cinemaAllList = [];
        this.formState.cinemaId = 0;
        let ret = await getCinemaList({
          page: 1,
          pageSize: 999999,
          organizationId: organizationId ? organizationId : undefined
        })
        if (ret.code === 200) {
          this.cinemaAllList = ret.data.list;
        }
      },
    }
  }
</script>

<style>
  .ui-form__item {
    margin-right: 30px;
  }
</style>
